export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-chord/index.js
// module id = Cc1o
// module chunks = 0